var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common" },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.pageData,
            rules: _vm.rules,
            "label-col": _vm.labelCol,
            "wrapper-col": _vm.wrapperCol
          }
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "登录名", prop: "loginName" } },
                    [
                      _c("a-input", {
                        attrs: {
                          disabled:
                            _vm.modalData.type != "create" ||
                            _vm.modalData.type == "detail"
                        },
                        model: {
                          value: _vm.pageData.loginName,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "loginName", $$v)
                          },
                          expression: "pageData.loginName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _vm.modalData.type == "create"
                    ? _c(
                        "a-form-model-item",
                        { attrs: { label: "登录密码", prop: "password" } },
                        [
                          _c("a-input", {
                            attrs: { type: "password" },
                            model: {
                              value: _vm.pageData.password,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "password", $$v)
                              },
                              expression: "pageData.password"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _vm.modalData.type == "create"
                    ? _c(
                        "a-form-model-item",
                        { attrs: { label: "密码确认", prop: "repassword" } },
                        [
                          _c("a-input", {
                            attrs: { type: "password" },
                            model: {
                              value: _vm.pageData.repassword,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "repassword", $$v)
                              },
                              expression: "pageData.repassword"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "姓名", prop: "userName" } },
                    [
                      _c("a-input", {
                        attrs: {
                          disabled:
                            _vm.modalData.type != "create" ||
                            _vm.modalData.type == "detail"
                        },
                        model: {
                          value: _vm.pageData.userName,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "userName", $$v)
                          },
                          expression: "pageData.userName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "身份证号", prop: "idCardNum" } },
                    [
                      _c("a-input", {
                        attrs: {
                          disabled:
                            _vm.modalData.type != "create" ||
                            _vm.modalData.type == "detail"
                        },
                        model: {
                          value: _vm.pageData.idCardNum,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "idCardNum", $$v)
                          },
                          expression: "pageData.idCardNum"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "部门", prop: "department" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.modalData.type == "detail" },
                        model: {
                          value: _vm.pageData.department,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "department", $$v)
                          },
                          expression: "pageData.department"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "手机号码", prop: "mobile" } },
                    [
                      _c("a-input", {
                        attrs: {
                          disabled:
                            _vm.modalData.type != "create" ||
                            _vm.modalData.type == "detail"
                        },
                        model: {
                          value: _vm.pageData.mobile,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "mobile", $$v)
                          },
                          expression: "pageData.mobile"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "电子邮箱", prop: "email" } },
                    [
                      _c("a-input", {
                        attrs: {
                          disabled:
                            _vm.modalData.type != "create" ||
                            _vm.modalData.type == "detail"
                        },
                        model: {
                          value: _vm.pageData.email,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "email", $$v)
                          },
                          expression: "pageData.email"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "状态", prop: "isEnable" } },
                    [
                      _c(
                        "a-select",
                        {
                          attrs: {
                            disabled:
                              (_vm.modalData.type != "create" &&
                                _vm.pageData.roleCode.indexOf("ROLE0000") >
                                  -1) ||
                              _vm.modalData.type == "detail"
                          },
                          model: {
                            value: _vm.pageData.isEnable,
                            callback: function($$v) {
                              _vm.$set(_vm.pageData, "isEnable", $$v)
                            },
                            expression: "pageData.isEnable"
                          }
                        },
                        [
                          _c("a-select-option", { attrs: { value: "1" } }, [
                            _vm._v("启用")
                          ]),
                          _vm._v(" "),
                          _c("a-select-option", { attrs: { value: "2" } }, [
                            _vm._v("停用")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _vm.modalData.type != "detail"
                    ? _c(
                        "a-form-model-item",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.modalData.type == "detail" },
                            model: {
                              value: _vm.pageData.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "remark", $$v)
                              },
                              expression: "pageData.remark"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "用户角色", prop: "roleCode" } },
                    [
                      _vm.$store.getters["home/getUserObj"].multiRole == 0
                        ? _c(
                            "a-checkbox-group",
                            {
                              on: { change: _vm.roleChange },
                              model: {
                                value: _vm.pageData.roleCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.pageData, "roleCode", $$v)
                                },
                                expression: "pageData.roleCode"
                              }
                            },
                            _vm._l(_vm.characterOptions, function(item) {
                              return _c(
                                "div",
                                {
                                  key: item.value,
                                  staticStyle: { "margin-top": "8px" }
                                },
                                [
                                  _c(
                                    "a-checkbox",
                                    {
                                      attrs: {
                                        value: item.value,
                                        name: "roleCode",
                                        checked: item.checked,
                                        disabled:
                                          item.disabled ||
                                          _vm.modalData.type == "detail"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item.name) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  item.value == "ROLE0002" &&
                                  _vm.roleLevelOptions.length > 0 &&
                                  _vm.isCoreCstRes
                                    ? [
                                        _c(
                                          "a-checkbox-group",
                                          {
                                            staticClass: "role-level",
                                            attrs: {
                                              value: _vm.roleLevelSelects
                                            },
                                            model: {
                                              value: _vm.roleLevelSelects,
                                              callback: function($$v) {
                                                _vm.roleLevelSelects = $$v
                                              },
                                              expression: "roleLevelSelects"
                                            }
                                          },
                                          _vm._l(_vm.roleLevelOptions, function(
                                            level,
                                            level_index
                                          ) {
                                            return _c(
                                              "a-checkbox",
                                              {
                                                key: level_index,
                                                attrs: {
                                                  value: level.roleLevel,
                                                  name: "roleLevel",
                                                  disabled:
                                                    _vm.modalData.type ==
                                                    "detail"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(level.roleLevel) +
                                                    "级\n                  "
                                                )
                                              ]
                                            )
                                          }),
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-color-orange role-level-tip"
                                          },
                                          [
                                            _vm._v(
                                              "多级复核员适用于祺信开立，祺信开立复核以最后一级操作为准。"
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            }),
                            0
                          )
                        : _c(
                            "a-radio-group",
                            {
                              staticStyle: { "margin-top": "8px" },
                              model: {
                                value: _vm.pageData.roleCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.pageData, "roleCode", $$v)
                                },
                                expression: "pageData.roleCode"
                              }
                            },
                            _vm._l(_vm.characterOptions, function(item) {
                              return _c(
                                "div",
                                { key: item.value },
                                [
                                  _c(
                                    "a-radio",
                                    {
                                      attrs: {
                                        value: item.value,
                                        name: "roleCode",
                                        disabled:
                                          item.disabled ||
                                          _vm.modalData.type == "detail" ||
                                          (_vm.pageData.roleCode &&
                                            _vm.pageData.roleCode.indexOf(
                                              "ROLE0000"
                                            ) > -1 &&
                                            _vm.$store.getters[
                                              "home/getUserObj"
                                            ].multiRole == "1")
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item.name) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  item.value == "ROLE0002" &&
                                  _vm.roleLevelOptions.length > 0 &&
                                  _vm.isCoreCstRes
                                    ? [
                                        _c(
                                          "a-checkbox-group",
                                          {
                                            staticClass: "role-level",
                                            attrs: {
                                              value: _vm.roleLevelSelects
                                            },
                                            model: {
                                              value: _vm.roleLevelSelects,
                                              callback: function($$v) {
                                                _vm.roleLevelSelects = $$v
                                              },
                                              expression: "roleLevelSelects"
                                            }
                                          },
                                          _vm._l(_vm.roleLevelOptions, function(
                                            level,
                                            level_index
                                          ) {
                                            return _c(
                                              "a-checkbox",
                                              {
                                                key: level_index,
                                                attrs: {
                                                  value: level.roleLevel,
                                                  name: "roleLevel",
                                                  disabled:
                                                    _vm.modalData.type ==
                                                    "detail"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(level.roleLevel) +
                                                    "级\n                  "
                                                )
                                              ]
                                            )
                                          }),
                                          1
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            }),
                            0
                          ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.roleWarn,
                              expression: "roleWarn"
                            }
                          ],
                          staticClass: "input-warn text-color-orange"
                        },
                        [_vm._v("注意:1个用户拥有多个角色可能存在风险")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a4e1b26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a4e1b26","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/user/user-create-modal.vue
// module id = KbRx
// module chunks = 1